// @flow

type Location = {
  name: string,
  state: string,
  country: string
};

export type SeoTrackList = {
  code: string,
  name: string,
  location: Location,
  imageName: string,
  imageLink: string
};

export type App = {
  promosList: Array<{ [string]: string }>
};

export type setPromosAction = {
  type: "PROMOS_LIST_SET",
  payload: Array<{ [string]: string }>
};

export type SetBetaOptinAction = {
  type: "SET_BETA_OPTIN",
  payload: boolean
};

export type SetSeoTrackList = {
  type: "SET_SEO_TRACK_LIST",
  payload: Array<SeoTrackList>
};

export type AppActions = setPromosAction | SetBetaOptinAction | SetSeoTrackList;

export const setPromosList = (
  promosList: Array<{ [string]: string }>
): setPromosAction => ({
  type: "PROMOS_LIST_SET",
  payload: promosList
});

export const setBetaOptin = (isBeta: boolean): SetBetaOptinAction => ({
  type: "SET_BETA_OPTIN",
  payload: isBeta
});

export const setSeoTrackList = (
  seoTrackList: Array<SeoTrackList>
): SetSeoTrackList => ({
  type: "SET_SEO_TRACK_LIST",
  payload: seoTrackList
});
